import { SxProps, Theme } from '@mui/material/styles';
import styled from 'styled-components';
import { colorPalette, getSpacing, typography } from 'stylesheet';

export const SecondaryTitle = styled.h2`
  ${typography.p1_bold}
  margin-top: ${getSpacing(5)};
`;

export const hamburgerDrawerPaperSx: SxProps<Theme> = {
  backgroundColor: colorPalette.primary,
  padding: 0,
  width: '80px',
  overflowX: 'hidden',
};
